

















import Vue from 'vue';
import {
  Component, Emit, Prop, Provide, Watch,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import {
  KAppToolbar,
  KFiSelector,
  KNavigationDrawer,
  KNoticeContainer,
  KPortalHeader,
} from '@kasasa/fbase-components';
import AuditResource from '@/api/audit/';
import JobResource from '@/api/job/';
import menuDefinitions from '@/menu';
import {
  Alert,
  AuthStore,
  MenuHeading,
  MenuItem,
  NoticeClass,
} from '@kasasa/fbase-components/lib';
import ReloadResource from '@/api/reload/ReloadResource';
import UpgradeResource from '@/api/upgrade/UpgradeResource';
import UserResource from '@/api/user/UserResource';
import ConfigResource from '@/api/config/ConfigResource';
import CycleValidationResource from '@/api/cyclevalidation/CycleValidationResource';
import FirstBaseTimeoutDialog from '@/components/fb-timeout-dialog.vue';
import { DailyLoadFiStatusResource } from '@/api/dashboard/DailyLoadFiStatusResource';
import { SavedDailyLoadFilterResource } from '@/api/dashboard/SavedDailyLoadFilterResource';
import { IsFederalHolidayResource } from './api/config';

@Component({
  components: {
    KPortalHeader,
    KNavigationDrawer,
    KNoticeContainer,
    KAppToolbar,
    KFiSelector,
    FirstBaseTimeoutDialog,
  },
  computed: mapState(['auth']),
})
export default class App extends Vue {
  appTitle: string = 'Tech Ops Admin';

  auth!: AuthStore;

  drawer: boolean = true;

  @Prop({
    type: Array,
    default() {
      return [...menuDefinitions];
    },
  })
  menuItems!: (MenuItem | MenuHeading)[];

  @Emit('error')
  showErrorMessage(error: string) {
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }

  @Provide('AuditResource')
  private auditResource: AuditResource = new AuditResource(this.$store);

  @Provide('JobResource')
  private jobResource: JobResource = new JobResource(this.$store);

  @Provide('ReloadResource')
  private reloadResource: ReloadResource = new ReloadResource(this.$store);

  @Provide('UpgradeResource')
  private upgradeResource: UpgradeResource = new UpgradeResource(this.$store);

  @Provide('UserResource')
  private userResource: UserResource = new UserResource(this.$store);

  @Provide('ConfigResource')
  private configResource: ConfigResource = new ConfigResource(this.$store);

  @Provide('CycleValidationResource')
  private cycleValidationResource: CycleValidationResource = new CycleValidationResource(this.$store);

  @Provide('DailyLoadFiStatusResource')
  private dailyLoadFiStatusResource: DailyLoadFiStatusResource = new DailyLoadFiStatusResource(this.$store);

  @Provide('SavedDailyLoadFilterResource')
  private savedDailyLoadFilterResource: SavedDailyLoadFilterResource = new SavedDailyLoadFilterResource(this.$store);

  @Provide('IsFederalHolidayResource')
  private isFederalHolidayResource: IsFederalHolidayResource = new IsFederalHolidayResource(this.$store);

  // FIRSTBase timeout warning dialog variables
  timerId: number = 0;

  showFirstBaseTimeoutDialog: boolean = false;

  DEFAULT_FIRSTBASE_TIMEOUT_WARNING_MS: number = 60 * 20 * 1000;
  // End of FIRSTBase timeout warning dialog variables

  onResetAuthAccessedTimer() {
    this.setShowFirstBaseTimeoutDialog(false);
    clearInterval(this.timerId);
    this.timerId = setInterval(
      () => this.setShowFirstBaseTimeoutDialog(true),
      this.DEFAULT_FIRSTBASE_TIMEOUT_WARNING_MS,
    );
  }

  setShowFirstBaseTimeoutDialog(value: boolean) {
    this.showFirstBaseTimeoutDialog = value;
  }

  @Watch('$store.state.lastAuthAccess')
  onAuthRenew() {
    this.onResetAuthAccessedTimer();
  }
}
